/**
 * Shown under a reply that hit the output-token cap (stop_reason
 * "max_tokens"): the text is real but cut off, so a quiet line invites the
 * couple to ask for the rest rather than leaving them staring at a sentence
 * that stops mid-thought.
 */

import { Stack, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import IconifyIcon from 'components/base/IconifyIcon';

const AssistantTruncatedHint = () => {
  const { t } = useTranslation();

  return (
    <Stack direction="row" spacing={0.75} alignItems="center" sx={{ pl: 0.5 }}>
      <IconifyIcon
        icon="material-symbols:info-outline-rounded"
        sx={{ fontSize: 15, color: 'text.secondary', flexShrink: 0 }}
      />
      <Typography variant="caption" sx={{ color: 'text.secondary' }}>
        {t('assistant.status.truncated')}
      </Typography>
    </Stack>
  );
};

export default AssistantTruncatedHint;
